import React from "react";
import { Box, Divider, Typography } from "@mui/material";

const FormSectionHeader = ({ title, subtitle }) => (
  <Box sx={{ mb: 2, mt: subtitle ? 0 : 3 }}>
    <Typography
      variant="h6"
      sx={{ fontSize: "16px", fontWeight: 700, color: "text.primary" }}
    >
      {title}
    </Typography>
    {subtitle && (
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
        {subtitle}
      </Typography>
    )}
    <Divider sx={{ mt: 1.5 }} />
  </Box>
);

export default FormSectionHeader;
